import { PropsWithChildren } from "react";
import CommonLayout from "@components/templates/common-layout";
import CommonHeader from "@components/organisms/common-header";
import CommonFooter from "@components/organisms/common-footer";

interface Props extends PropsWithChildren {}

export default function HelpCenterLayout(props: Props): JSX.Element {
  return (
    <CommonLayout
      Header={<CommonHeader />}
      Footer={<CommonFooter />}
      className="bg-memod-base px-0 md:px-4 min-h-0"
    >
      <div className="mx-auto w-full md:max-w-6xl text-white">
        {props.children}
      </div>
    </CommonLayout>
  );
}
